import LeaveFeedback from '@components/Feedback/LeaveFeedback.component'
import {
  Box,
  Button,
  Typography,
  CircularProgress,
} from '@mui/material'
import { createFileRoute, useNavigate, useParams } from '@tanstack/react-router'
import { useState, useEffect } from 'react'
import axios from 'axios'
import NoData from 'icons/NoData.icon'

export const Route = createFileRoute('/(dashboard)/_dashboard/results-overview/$id')({
  component: RouteComponent,
})


function RouteComponent() {
  const [open, setOpen] = useState(false)
  const navigate = useNavigate()
  const { id: interviewId } = useParams({ from: '/(dashboard)/_dashboard/results-overview/$id' })
  const [results, setResults] = useState<any>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchResults = async () => {
      try {
        const token = localStorage.getItem('token')
        const response = await axios.get(
          `https://interviewer.runasp.net/api/submissionInterviews/${interviewId}/results`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        )
        console.log('zavrsetak', response.data);
        setResults(response.data)
      } catch (error) {
        console.error('Error fetching results:', error)
      } finally {
        setLoading(false)
      }
    }

    if (interviewId) {
      fetchResults()
    }
  }, [interviewId])

  const handleOpen = () => {
    setOpen(true)
  }
  const handleClose = () => setOpen(false)

  const handleSubmitFeedback = (data: { grade: number; comment: string }) => {
    handleClose()
  }

  if (loading) {
    return (
     <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    )
  }

  if (!results) {
    return (
      <NoData />
    )
  }

  return (
    <Box sx={{
      width: {xs: '100%', md: '80%'},
      mx: 'auto',
      padding: {xs: '20px 16px', md: '125px 75px'}
    }}>
      <Box sx={{py: '20px'}}>
        <Typography variant='h1'>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Perferendis, quod?</Typography>
        <Typography variant='h4'>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Perferendis, quod?</Typography>
      </Box>
      <Box
        sx={{
          background: '#ffffff',
          padding: '32px',
          borderRadius: '16px',
          border: '1px solid #F0F1F3',
          boxShadow: '0px 1px 2px 0px #0205111A',
        }}
      >
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          <Typography variant="h2">You're doing great!</Typography>
          <Typography>
              It is a long established fact that a reader will be distracted by
            the readable content of a page when looking at its layout. The
            point of using Lorem Ipsum is that it has a more-or-less normal
            distribution of letters, as opposed to using 'Content here,
            content here', making it look like readable English? The point of
            using Lorem Ipsum is that it has a more-or-less normal
            distribution of letters, as opposed to using 'Content here,
            content here', making it look like readable English?
          </Typography>
        </Box>
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          alignItems: 'center',
          gap: '20px',
          mt: '20px',
        }}
      >
        <Button
          variant="contained"
          color="primary"
          fullWidth
          onClick={() => {
            navigate({
              to: '/history',
            })
          }}
        >
          Finish interview
        </Button>
        <Button
          variant="outlined"
          color="primary"
          fullWidth
          onClick={handleOpen}
        >
          Leave Feedback
        </Button>
      </Box>

      <LeaveFeedback
        open={open}
        onClose={handleClose}
        onSubmit={handleSubmitFeedback}
        interviewId={interviewId}
        endpoint='https://interviewer.runasp.net/api/submissionInterviews'
      />
    </Box>
  )
}
